import Logo from './Logo';
import { LogoProps, LogoValueProps } from './types';

export type { LogoProps, LogoValueProps };
export default Logo;
